import {useContext, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {Modal, Select, Typography} from 'antd'
import {PromoteChangesContext, SHOW_SELECT_FILES_POPUP,} from '../context/context'
import {getRequest} from '../../../services/base'
import useDebouncedValue from '../../../utils/common_function'

const SelectVehicles = () => {
  const intl = useIntl()
  const [, dispatch] = useContext(PromoteChangesContext)
  const [modal, contextHolder] = Modal.useModal()

  const [searchVehicles, setSearchVehicles] = useState('')
  const [selectedVehicle, setSelectedVehicle] = useState(null)
  const [vehiclesList, setVehiclesList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [searchFailed, setSearchFailed] = useState(false)
  const debouncedSearch = useDebouncedValue(searchVehicles, 500)

  useEffect(() => {
    getVehiclesList('')
  }, [])

  useEffect(() => {
    getVehiclesList(searchVehicles)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearch])

  const getVehiclesList = async (search = '') => {
    setIsLoading(true)
    let res = await getRequest(`/api/vehicles/?search=${search}&limit=25`)
    // Search-as-you-type: shown in the list placeholder, not as a toast.
    if (res?.status === false) {
      setSearchFailed(true)
      setVehiclesList([])
      setIsLoading(false)
      return
    }
    setSearchFailed(false)
    setVehiclesList(res?.results || [])
    setIsLoading(false)
  }

  const confirmPromote = (vehicle) => {
    modal.confirm({
      title: intl.formatMessage({ id: 'promoteChanges.promoteChangesTitle' }),
      content: intl.formatMessage({
        id: 'promoteChanges.selectVehicleConfirm',
      }),
      centered: true,
      maskClosable: false,
      okText: intl.formatMessage({ id: 'promoteChanges.continue' }),
      cancelText: intl.formatMessage({ id: 'promoteChanges.cancel' }),
      onOk: () => {
        dispatch({
          type: SHOW_SELECT_FILES_POPUP,
          data: true,
          selectedVehicle: vehicle,
          selectedFiles: {},
        })
        setSelectedVehicle(null)
      },
    })
  }

  return (
    <>
      {contextHolder}
      <Select
        showSearch
        allowClear
        className="promote-changes-select-vehicle"
        placeholder={intl.formatMessage({
          id: 'promoteChanges.selectVehicles',
        })}
        options={vehiclesList.map((vehicle) => ({
          value: vehicle?.vehicle_id,
          label: `${vehicle?.name} (${vehicle?.make_model_id})`,
          vehicle,
        }))}
        onChange={(value, option) =>
          setSelectedVehicle(option?.vehicle ?? null)
        }
        onSelect={(value, option) => confirmPromote(option?.vehicle)}
        onSearch={(value) => setSearchVehicles(value)}
        filterOption={false}
        loading={isLoading}
        notFoundContent={
          searchFailed ? (
            <Typography.Text type="danger" style={{ color: 'var(--color-form-link-danger)' }}>
              {intl.formatMessage({ id: 'generic.searchFailed' })}
            </Typography.Text>
          ) : (
            intl.formatMessage({ id: 'promoteChanges.noRecords' })
          )
        }
        value={selectedVehicle?.vehicle_id}
      />
    </>
  )
}

export default SelectVehicles
